(function(){
  // Strict-enough RFC 5322 subset
  var EMAIL_RE = /^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$/i;

  // Hard-block list — junk + disposable domains we've actually seen bouncing.
  var BLOCK_DOMAINS = new Set([
    'dropsinaus.com','soupreme.xyz',
    // disposable
    '10minutemail.com','mailinator.com','tempmail.com','guerrillamail.com',
    'guerrillamail.net','guerrillamail.org','yopmail.com','throwawaymail.com',
    'sharklasers.com','spam4.me','tempinbox.com','trashmail.com','getairmail.com',
    'mintemail.com','mailcatch.com','fakeinbox.com','emailondeck.com','maildrop.cc',
    'dispostable.com','spambog.com','spambox.us','mvrht.net','tempr.email',
    'tmail.ws','tmail.io','one-time.email','tmpmail.org','spambox.us'
  ]);

  // Domain typo map: typo -> intended. Lower-cased.
  var TYPO_MAP = {
    // gmail
    'gmial.com':'gmail.com','gmai.com':'gmail.com','gmal.com':'gmail.com','gmali.com':'gmail.com',
    'gmaill.com':'gmail.com','gnail.com':'gmail.com','gamil.com':'gmail.com','gmil.com':'gmail.com',
    'gmail.cm':'gmail.com','gmail.co':'gmail.com','gmail.con':'gmail.com','gmail.om':'gmail.com',
    'gmail.cmo':'gmail.com','gmail.coom':'gmail.com','gmail.comm':'gmail.com','gmail.colm':'gmail.com',
    'gmail.c':'gmail.com','gmail.ccm':'gmail.com','gmail.cum':'gmail.com',
    // yahoo
    'yhoo.com':'yahoo.com','yaho.com':'yahoo.com','yahooo.com':'yahoo.com','yhaoo.com':'yahoo.com',
    'yahoo.cm':'yahoo.com','yahoo.co':'yahoo.com','yahoo.con':'yahoo.com','yahoo.om':'yahoo.com',
    'yahoo.comm':'yahoo.com','yhoo.com.au':'yahoo.com.au','yahoo.coom':'yahoo.com','ahoo.com':'yahoo.com',
    // hotmail
    'hotmial.com':'hotmail.com','hotmai.com':'hotmail.com','hotmal.com':'hotmail.com','hotmaill.com':'hotmail.com',
    'hotnail.com':'hotmail.com','homail.com':'hotmail.com','hotmail.cm':'hotmail.com','hotmail.co':'hotmail.com',
    'hotmail.con':'hotmail.com','hotmail.om':'hotmail.com','hotmail.comm':'hotmail.com','hotmail.cmo':'hotmail.com',
    // outlook
    'outlok.com':'outlook.com','outloo.com':'outlook.com','outllok.com':'outlook.com','outloook.com':'outlook.com',
    'outlook.cm':'outlook.com','outlook.co':'outlook.com','outlook.con':'outlook.com','outlook.om':'outlook.com',
    'outlook.comm':'outlook.com',
    // icloud
    'iclud.com':'icloud.com','iclou.com':'icloud.com','icloud.cm':'icloud.com','icloud.co':'icloud.com',
    'icloud.con':'icloud.com','icould.com':'icloud.com','icloud.om':'icloud.com','icloud.comm':'icloud.com',
    // me
    'me.cm':'me.com','me.co':'me.com',
    // au common
    'live.com.a':'live.com.au','live.com.aum':'live.com.au','live.cm.au':'live.com.au',
    'hotmail.com.a':'hotmail.com.au','outlook.com.a':'outlook.com.au'
  };

  function correct(email) {
    if (!email || email.indexOf('@') < 0) return null;
    var parts = email.toLowerCase().trim().split('@');
    var local = parts[0]; var domain = parts[1];
    if (TYPO_MAP[domain]) return local + '@' + TYPO_MAP[domain];
    return null;
  }

  function getMsgEl(input) {
    var sib = input.parentNode.querySelector(':scope > .trc-ev-msg');
    if (sib) return sib;
    var el = document.createElement('div');
    el.className = 'trc-ev-msg';
    input.parentNode.appendChild(el);
    return el;
  }

  function clearMsg(input) {
    var m = input.parentNode.querySelector(':scope > .trc-ev-msg');
    if (m) m.remove();
  }

  function setError(input, text) {
    var m = getMsgEl(input);
    m.className = 'trc-ev-msg err';
    m.textContent = text;
  }

  function setSuggestion(input, suggestion, accept) {
    var m = getMsgEl(input);
    m.className = 'trc-ev-msg warn';
    m.innerHTML = 'Did you mean <button type="button" class="trc-ev-fix"></button>?';
    var btn = m.querySelector('.trc-ev-fix');
    btn.textContent = suggestion;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      input.value = suggestion;
      clearMsg(input);
      accept();
    });
  }

  function bind(form) {
    if (form.dataset.trcEvBound) return;
    form.dataset.trcEvBound = '1';
    var input = form.querySelector('input[type="email"]');
    if (!input) return;

    input.addEventListener('input', function(){ clearMsg(input); });

    form.addEventListener('submit', function(e){
      var val = (input.value || '').trim();
      if (!val) return; // browser required-handling kicks in
      if (!EMAIL_RE.test(val)) {
        e.preventDefault();
        setError(input, 'That doesn’t look like a valid email.');
        return;
      }
      var domain = val.toLowerCase().split('@')[1];
      if (BLOCK_DOMAINS.has(domain)) {
        e.preventDefault();
        setError(input, 'Please use a real personal email — that address can’t receive our updates.');
        return;
      }
      var suggestion = correct(val);
      if (suggestion && !form.dataset.trcEvAccepted) {
        e.preventDefault();
        setSuggestion(input, suggestion, function(){
          form.dataset.trcEvAccepted = '1';
          // re-submit with the corrected value
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
        return;
      }
    }, true);
  }

  // Hook every form that collects an email — EXCEPT login (email already exists)
  // and Shopify's checkout/cart/search/localization forms.
  function shouldSkip(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/account/login') >= 0) return true;
    if (action.indexOf('/checkout') >= 0) return true;
    if (form.id === 'customer_login') return true;
    return false;
  }
  function scan() {
    document.querySelectorAll('form').forEach(function(f){
      if (!f.querySelector('input[type="email"]')) return;
      if (shouldSkip(f)) return;
      bind(f);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // Also re-scan on DOM changes (e.g. AJAX section re-render)
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
